import React from 'react';

import Snapshot from './Snapshot';

function SnapshotRow(props: { posts: Array<ReportPost> }) {
  return (
    <div className="post-container page-break">
      <div className="row page-break">
        {props.posts.map((obj) => (
          <Snapshot key={obj.id} post={obj} />
        ))}
      </div>
    </div>
  );
}

export default SnapshotRow;
